$(function() {

    // On Key
    $('input.number').keyup(function(e) { maskNumberInputs(this, e); });

});

function maskNumberInputs($this, e) {

    // skip for arrow keys
    if(e.which >= 37 && e.which <= 40) return;

    // format number
    $($this).val(function(index, value) {
        return maskNumberCommas(value);
    });
}

function maskNumberCommas(value) {

    if (typeof value !== 'string') {
        value = String(value);
    }

    return value
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}